export const dashboard: Dashboard = {
    rowHeight: 175,
    editable: true,
    columns: {
        'xxs': 1,
        'xs': 2,
        'sm': 3,
        'md': 4,
        'lg': 4,
    },
    widgets: [{
        name: 'organisation.upcomingGames',
        label: 'organisations.upcomingGames',
        x: 0,
        y: 0,
        height: 2,
        props: {}
    }, {
        name: 'sports.pastGamesWoScores',
        label: 'sports.pastGamesWoScores',
        mustPossessAbility: {action: 'updateScore', subject: 'games'},
        x: 1,
        y: 0,
        height: 2,
        props: {}
    }, {
        name: 'sports.unconfirmedGameScores',
        label: 'sports.unconfirmedGameScores',
        mustPossessAbility: {action: 'confirmScore', subject: 'games'},
        x: 1,
        y: 0,
        height: 2,
        props: {}
    }, {
        name: 'invoices.openInvoices',
        label: 'invoices.openInvoices',
        mustPossessAbility: {action: 'viewAny', subject: 'invoices'},
        x: 1,
        y: 0,
        height: 2,
        props: {}
    }],
}